import Vue from 'vue'
import screenLoading from '../../src/components/screenLoading.vue'
function getSet(el) {
    let Box = el.getBoundingClientRect(),
        doc = el.ownerDocument,
        body = doc.body,
        html = doc.documentElement,
        clientTop = html.clientTop || body.clientTop || 0,
        clientLeft = html.clientLeft || body.clientLeft || 0,
        top = Box.top + (self.pageYOffset || html.scrollTop || body.scrollTop) - clientTop,
        left = Box.left + (self.pageXOffset || html.scrollLeft || body.scrollLeft) - clientLeft;
    return { 'top': top, 'left': left };
}
function insertDom(el, mask) {
    const { top, left } = getSet(el);
    mask.height = el.offsetHeight + 'px'
    mask.width = el.offsetWidth + 'px'
    mask.left = left + 'px'
    mask.top = top + 'px'
    el.appendChild(mask.$el)
    mask.show = true
}
const Mask = Vue.extend(screenLoading)
Vue.directive('screen-loading', {
    inserted: function (el, binding) {
        // console.log(el, binding.value);
        const mask = new Mask({
            el: document.createElement('div'),
            data() { return {} }
        })
        setTimeout(() => {
            const { top, left } = getSet(el);
            let { value } = binding.value;
            // 
            mask.height = el.offsetHeight + 'px'
            mask.width = el.offsetWidth + 'px'
            mask.left = left + 'px'
            mask.top = top + 'px'
            el.instance = mask
            el.mask = mask.$el
            value && insertDom(el, mask)
        }, 200);
    },
    update: function (el, binding) {
        setTimeout(() => {
            if (binding.oldValue !== binding.value) {
                if (binding.value) { insertDom(el, el.instance) }
                else {
                    el.instance.show = false
                    el.mask && el.mask.parentNode && el.mask.parentNode.removeChild(el.mask)
                }
            }
        }, 300);
    },
    unbind: function (el, binding) {
        el.instance && el.instance.$destroy()
    }
})

//弹窗全局拖动指令
Vue.directive('dialogDrag', {
    bind(el, binding, node, oldNode) {
        const dragEle = binding.expression ? el : el.querySelector('.el-dialog')
        const currentSty = dragEle.currentSty || window.getComputedStyle(dragEle, null)
        dragEle.onmousedown = e => {
            e = event || window.event;
            var disX = e.clientX - dragEle.offsetLeft;
            var disY = e.clientY - dragEle.offsetTop;
            document.onmousemove = function (e) {
                e = event || window.event;
                let boxLeft = e.clientX - disX;
                let boxTop = e.clientY - disY;
                let clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
                let clientWidth = document.documentElement.clientWidth || document.body.clientWidth;
                if (boxLeft < 0) {
                    boxLeft = 0;
                } else if (boxLeft > clientWidth - dragEle.offsetWidth) {
                    boxLeft = clientWidth - dragEle.offsetWidth;
                }

                if (boxTop < 0) {
                    boxTop = 0;
                } else if (boxTop > clientHeight - dragEle.offsetHeight) {
                    boxTop = clientHeight - dragEle.offsetHeight;
                }

                dragEle.style.left = boxLeft + "px";
                dragEle.style.top = boxTop + "px";
            }
            document.onmouseup = function (e2) {
                if (e.clientX == e2.clientX && e.clientY == e2.clientY) {
                    node.context.handleClick && node.context.handleClick()
                }
                document.onmousemove = null;
                document.onmouseup = null;
            }
        }

    }
})